<template>
  <div class="fb">
    <label v-for="f in filters" :key="f.name" class="fb-filter">
      <span>{{ f.label || f.name }}</span>
      <select v-if="f.type === 'choice'" :value="values[f.name]" @change="$emit('change', f.name, $event.target.value)">
        <option value="">Any</option>
        <option v-for="o in f.options || []" :key="o" :value="o">{{ o }}</option>
      </select>
      <input v-else-if="f.type === 'year' || f.type === 'number'" :value="values[f.name]" type="number" @change="$emit('change', f.name, $event.target.value === '' ? '' : Number($event.target.value))">
      <span v-else-if="f.type === 'entity'" class="fb-entity">
        <EntitySearch_Single button-text="Choose" modal-title="Choose an entity" button-class="fb-pick" @entity-selected="pick(f.name, $event)" />
        <span v-if="values[f.name]" class="sensitive">{{ names[f.name] || `Entity ${values[f.name]}` }}</span>
        <button v-if="values[f.name]" type="button" class="fb-clear" @click="$emit('change', f.name, ''); names[f.name] = ''">Clear</button>
      </span>
      <input v-else-if="f.type === 'date'" :value="values[f.name]" type="date" @change="$emit('change', f.name, $event.target.value)">
      <input v-else :value="values[f.name]" type="text" @change="$emit('change', f.name, $event.target.value)">
    </label>
  </div>
</template>

<script>
import EntitySearch_Single from '@/components/widgetcomponents/Search_Widgets/EntitySearch_Single.vue';

export default {
  name: 'FilterBar',
  components: { EntitySearch_Single },
  props: {
    filters: { type: Array, required: true },
    values: { type: Object, default: () => ({}) },
  },
  emits: ['change'],
  data() {
    return { names: {} };
  },
  methods: {
    pick(name, entity) {
      if (!entity) return;
      this.names = { ...this.names, [name]: entity.name || entity.entity_name || '' };
      this.$emit('change', name, Number(entity.id));
    },
  },
};
</script>

<style scoped>
.fb { display: flex; gap: 10px; flex-wrap: wrap; }
.fb-filter { display: flex; align-items: center; gap: 6px; font-size: 12px; color: #56534d; }
.fb-entity { display: inline-flex; align-items: center; gap: 6px; }
.fb-clear { font-size: 11.5px; color: #626264; text-decoration: underline; }
.fb-filter input, .fb-filter select { font-size: 12.5px; padding: 4px 6px; border: 1px solid #dad8d2; border-radius: 6px; background: #fff; }
</style>
